<template>
  <div class="action-mage content-430">
    <Breadcrumb style="margin-bottom: 30px">
      <BreadcrumbItem>基础信息中心</BreadcrumbItem>
      <BreadcrumbItem>单位管理</BreadcrumbItem>
      <BreadcrumbItem>学校管理</BreadcrumbItem>
      <BreadcrumbItem>{{ schoolName }}</BreadcrumbItem>
    </Breadcrumb>
    <div class="tab-box">
      <div
        v-for="(item, index) in tabList"
        :key="index"
        :class="index === active ? 'tab-item-active' : ''"
        class="tab-item"
        @click="handleSwitchTab(index)"
      >
        <span>{{ item.name }}</span>
      </div>
    </div>
    <div class="tab-content">
      <div v-show="tabLeft.length > 1" class="content-left">
        <div
          v-for="(item, index) in tabLeft"
          :key="index"
          class="left-item"
          :class="tabLeftActive === index ? 'left-item-active' : ''"
          @click="handleChangeTabLeft(index)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="content-right" style="padding-bottom: 50px">
        <Form
          v-show="activeItem === '家长端自动退款设置'"
          :label-width="170"
          style="position: relative"
        >
          <FormItem label="是否允许学生未入班前发起退款后系统自动审批：">
            <div
              class="flex flexrow flexsb"
              style="position: relative; top: 8px"
            >
              <RadioGroup v-model="isEnable">
                <Radio :label="0">否</Radio>
                <Radio :label="1">是</Radio>
              </RadioGroup>
              <Button
                type="primary"
                style="width: 100px"
                @click="handleToOpenRec('AUTO_REFUND')"
              >操作记录</Button>
            </div>
          </FormItem>
          <FormItem
            v-show="isEnable == 1"
            label="对应订单所属学期："
            :required="true"
          >
            <CascaderYearTerms
              v-if="!initloading"
              ref="cascaderYearTerms"
              style="width: 200px"
              :has-default-value="true"
              :cache-year-terms="initYear"
              :placeholder="`请选择学期`"
              :clearable="true"
            >
            </CascaderYearTerms>
          </FormItem>
          <FormItem
            v-show="isEnable == 1"
            label="自动退款截止时间："
            :required="true"
            style="padding-bottom: 80px"
          >
            <DatePicker
              :value="autoRefundTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              placeholder="自动退款截止时间"
              style="width: 200px"
              @on-change="handleTime"
            ></DatePicker>
            <p>
              ①否：表示家长发起的退款，需经学校教务人员审批后方可进行才退款。
            </p>
            <p>
              ②是：表示在该商品的
              <span class="redweight">已付款</span> 人数<span class="redweight">且未入班</span>时，家长端发起的退款后，对应学期下的订单在<span class="redweight">自动退款截止时间前</span>，系统自动将自动审批通过家长的退款申请单，并进行所申请节次的全额退款。
            </p>
            <p>③系统每5分钟定时执行符合条件的自动退款处理单。</p>
          </FormItem>
        </Form>

        <Form
          v-show="activeItem === '学校端是否可见审批'"
          :label-width="210"
          style="position: relative"
        >
          <FormItem label="学校端是否可见操作操作按钮：">
            <div
              class="flex flexrow flexsb"
              style="position: relative; top: 8px"
            >
              <RadioGroup v-model="configStatus">
                <Radio :label="0">否</Radio>
                <Radio :label="1">是</Radio>
              </RadioGroup>
              <Button
                type="primary"
                style="width: 100px"
                @click="handleToOpenRec('SET_CONFIG_OF_REFUND_APPROVE_SCH_PERMISSION')"
              >操作记录</Button>
            </div>
            <p>①否：学校端不可见审批退款按钮（订单退款、请假可退款、批量退款）。即使用户有权限也不可见。</p>
            <p>②是：学校端有权限的用户可见</p>
          </FormItem>
        </Form>

        <CourseOthers
          v-show="activeItem === '课程报名设置'"
          ref="courseOthersRefs"
          :school-id="schoolId"
          :other-info="{
            switchParentPhoneNumber,
            switchCourseTeacher,
            switchOriginalSchool
          }"
          @on-message="onMessage"
        ></CourseOthers>

        <Form
          v-show="activeItem === '填写原所在学校'"
          class="content-right-box"
          :label-width="300"
        >
          <FormItem label="家长绑定学生时是否填写学生原所在学校:"><i-switch v-model="switchOriginalSchool"></i-switch>
          </FormItem>
          <p>关闭：闭关后，绑定学生时不填写学生原所在学校;</p>
          <p>
            开启：开启后，绑定该学校的学生时需要填写原所在学校。适用于寒暑假学校开设托管课程，其他学校的学生到校参与托管，区分是否是本校的学生。
          </p>
        </Form>
        <Form v-show="activeItem === '屏蔽家长手机号码'" :label-width="120">
          <FormItem label="屏蔽家长号码:">
            <i-switch v-model="switchParentPhoneNumber"></i-switch>
            <p>按钮开关控制机构端订单管理中是否查看家长的手机号码</p>
          </FormItem>
        </Form>
        <Form v-show="activeItem === '屏蔽任教安排'" :label-width="120">
          <FormItem label="屏蔽任教安排:">
            <i-switch v-model="switchCourseTeacher"></i-switch>
            <p>按钮开关控制对应学校的机构端没有权限去修改教师的任教安排</p>
          </FormItem>
        </Form>
        <Form v-show="activeItem === '参与平台发放教师工资'" :label-width="120">
          <FormItem label="是否参与平台发放教师工资:">
            <i-switch
              v-model="switchPayWages"
              :loading="loadingSwitch"
              @on-change="handleChangeSalary"
            ></i-switch>
            <p>
              ①是：表示该学校单位参与平台发放教师工资，平台会自动统计每月教师结算工资金额，经过学校确认、平台核对后，即可通过平台给教师发送工资。
              教师需先在平台进件生成账户钱包后，方可接收工资转账。
            </p>
            <p>
              ②否，默认学校不参与平台发送教师工资。若设置成：是，再次设置成：否，则不影响之前已生成的教师工资数据。
            </p>
            <p style="color: red">
              ③提示，该设置目前仅适用于平安银行下的部分区域学校，请设置前联系客服确认，防止设置后无效。
            </p>
          </FormItem>
        </Form>
        <Form v-show="activeItem === '教师考勤补签'" :label-width="250">
          <FormItem label="教师端最多可补签多少天前的考勤:">
            <Row :gutter="16">
              <Col span="6">
                <Input v-model="teaSignDayScope" placeholder="请填写"></Input>
              </Col>
              <Col span="2"> 天 </Col>
            </Row>
            <p class="tips">
              提示：-1
              表示不限，可任意补签；0表示只能补签当天的考勤；31表示只能补签距离当前日期31天前的班级考勤记录。最大值输入为999。
            </p>
          </FormItem>
        </Form>
        <SetSignLocation
          v-show="activeItem === '教师考勤位置打卡设置'"
          v-model="switchSignPlace"
          :org-id="schoolId"
        ></SetSignLocation>
        <SignStatusNotification
          v-show="activeItem === '学生考勤状态通知设置'"
          ref="signStatusNotificationRef"
          :org-id="schoolId"
        >
        </SignStatusNotification>
        <Form
          v-show="activeItem === '家长端发起学生请假审批设置'"
          :label-width="250"
        >
          <FormItem label="家长端发起学生请假是否需要任课教师审批:">
            <RadioGroup v-model="autoCheckLeavePassSwitch">
              <Radio :label="1">否</Radio>
              <Radio :label="0">是</Radio>
            </RadioGroup>
            <p class="tips">
              设置成"否"，家长端发起学生请假，将自动审批通过，无需任课教师或其他管理员审批
            </p>
          </FormItem>
        </Form>
        <Form v-show="activeItem === '家长端发起请假截止'" :label-width="250">
          <FormItem label="发起请假设置:">
            <div>
              家长端发起请假申请，最迟需在课程日期当天的
              <TimePicker
                v-model="hourAndMinTime"
                format="HH:mm"
                type="time"
                placeholder="23:59"
                style="width: 150px"
              ></TimePicker>
              前，发起申请！
            </div>
            <p class="tips">默认23:59分前，可发起当前的申请！</p>
          </FormItem>
        </Form>
        <div v-show="active == 4">
          <SealShowAndUpload
            :id="schoolId"
            :action-type="`school`"
          ></SealShowAndUpload>
        </div>

        <ReceiptTemplete
          v-show="activeItem === '电子收据协议模板'"
          ref="ReceiptTemplete"
          :school-id="schoolId"
        ></ReceiptTemplete>
        <SettingParentSchool
          v-show="activeItem === '家长绑定配置'"
          :org-id="schoolId"
        ></SettingParentSchool>
        <div v-if="showSaveAndCancelBtn">
          <Button style="margin-right: 16px" @click="handleCancel">取消</Button>
          <Button type="primary" @click="handleSaveBtn">保存</Button>
        </div>
        <div v-if="activeItem == '退款设置'">
          <Button style="margin-right: 16px" @click="handleCancel">取消</Button>
          <Button
            v-auth="`SET_AUTO_REFUND`"
            type="primary"
            @click="handleSaveBtn"
          >提交</Button>
        </div>
      </div>
    </div>
    <CheckCodeModal
      ref="smsCodeModalRef"
      :title="`自动退款设置确认`"
      :check-type="`setAutoRefund`"
      :modal-loading="modalLoading"
      @on-finish="delTrue"
    >
      <template #header>
        <div>
          <p style="margin-bottom: 8px">
            请仔细核对当前的退款设置方式，设置后立即生效！
          </p>
        </div>
      </template>
    </CheckCodeModal>
    <Modal
      v-model="showtips"
      :title="'提示'"
      :footer-hide="true"
      :closable="false"
      :mask-closable="false"
    >
      <div class="flex flexcol flexjc flexac" style="padding: 20px">
        <div class="flex flexcol flexjc">
          <Icon type="ios-checkmark-circle" size="70" color="green"></Icon>
          <span
            style="
              text-align: center;
              font-size: 14px;
              margin-top: 20px;
              font-weight: bold;
            "
          >自动退款设置成功！</span>
        </div>
        <Button
          type="primary"
          style="margin-top: 20px; width: 100px"
          @click="closeBtn"
        >关闭</Button>
      </div>
    </Modal>
    <RecModal ref="recModal" :code-type-map="codeTypeMap"></RecModal>
  </div>
</template>
<script>
import { mapMutations } from 'vuex';
import CascaderYearTerms from '@c/searchBlock/CascaderYearTerms.vue';
import CourseOthers from '../assets/components/CourseOthers.vue';
import SignStatusNotification from '../assets/components/SignStatusNotification.vue';

import courseCenterApi from '@/request/courseCenter/courseCenterApi.js';
import commonApi from '@/request/common/index';
import SetSignLocation from '../assets/components/SetSignLocation.vue';
import SealShowAndUpload from '../assets/components/SealShowAndUpload.vue';
import CheckCodeModal from '../assets/components/CheckCodeModal.vue';
import RecModal from '@c/RecModal.vue';
// import PlatServeAgreementTemplete from '../assets/components/PlatServeAgreementTemplete.vue';
import ReceiptTemplete from '../assets/components/ReceiptTemplete.vue';
import SettingParentSchool from '../assets/components/SettingParentSchool.vue';
export default {
  name: 'ResourceSchoolActionMage',
  components: {
    CourseOthers,
    SetSignLocation,
    SealShowAndUpload,
    CascaderYearTerms,
    CheckCodeModal,
    RecModal,
    // PlatServeAgreementTemplete,
    ReceiptTemplete,
    SettingParentSchool,
    SignStatusNotification
  },
  // 当是要去添加服务协议页面的时候，保持当前页面组件
  beforeRouteLeave(to, from, next) {
    if (
      to.name === 'basicInfoCenter_company_schoolMage_addReceiptTemplete'
    ) {
      this.PUSH_CACHEROUTE('ResourceSchoolActionMage');
    } else {

    }

    next();
  },
  data() {
    return {
      initYear: [null, null],
      tabList: [
        {
          name: '课程报名相关设置',
          tabLeft: [
            {
              name: '课程报名设置'
            },
            {
              name: '填写原所在学校'
            }, {
              name: '家长绑定配置'
            }
          ]
        },
        {
          name: '屏蔽相关设置',
          tabLeft: [
            {
              name: '屏蔽家长手机号码'
            },
            {
              name: '屏蔽任教安排'
            }
          ]
        },
        {
          name: '参与平台发放教师工资',
          tabLeft: [
            {
              name: '参与平台发放教师工资'
            }
          ]
        },
        {
          name: '教务相关设置',
          tabLeft: [
            {
              name: '教师考勤补签'
            },
            {
              name: '教师考勤位置打卡设置'
            },
            {
              name: '学生考勤状态通知设置'
            },
            {
              name: '家长端发起学生请假审批设置'
            },
            {
              name: '家长端发起请假截止'
            }
          ]
        },
        {
          name: '印章设置',
          tabLeft: [
            {
              name: '学校印章设置'
            }
          ]
        },
        {
          name: '退款设置',
          tabLeft: [
            {
              name: '家长端自动退款设置'
            },
            {
              name: '学校端是否可见审批'
            }
          ]
        },
        {
          name: '电子收据协议模板',
          tabLeft: [
            // {
            //   name: '平台服务协议模板'
            // },
            {
              name: '电子收据协议模板'
            }
          ]
        }

      ],
      active: 0,
      tabLeftActive: 0,
      schoolId: '',
      switchParentPhoneNumber: false, // 屏蔽家长手机号码
      switchCourseTeacher: false, // 屏蔽任教安排
      switchOriginalSchool: false, // 是否填写原所在学校
      switchPayWages: false, // 是否参与平台发放教师工资 1开放 0不开放
      switchSignPlace: false, // 是否开启教师位置打卡 1开启 0不开启
      teaSignDayScope: '-1',
      loadingSwitch: false,
      infoSwitchPayWages: '',
      showtips: false,
      modalLoading: false,
      isEnable: 0,
      configStatus: 0,
      autoRefundTime: '',
      schoolName: '',
      initloading: false,

      studentSignStatusNotification: {
        settingSwitch: 0,
        signStatus: [],
        notifyUserType: [],
        pushMethod: []
      }, // 学生考勤状态通知设置
      hourAndMinTime: '',
      autoCheckLeavePassSwitch: 0, // 0否 1是
      codeTypeMap: {
        'AUTO_REFUND': '自动退款',
        'SET_CONFIG_OF_REFUND_APPROVE_SCH_PERMISSION': '学校端是否可见操作操作按钮'
      }
    };
  },
  computed: {

    tabLeft() {
      console.log(this.active, '拿到的active');
      console.log(this.tabList[this.active].tabLeft);
      return this.tabList[this.active].tabLeft;
    },
    activeItem() {
      return this.tabList[this.active].tabLeft[this.tabLeftActive].name;
    },
    // 是否展示  保存、取消按钮
    showSaveAndCancelBtn() {
      const hideBtnList = ['教师考勤位置打卡设置', '学校印章设置', '平台服务协议模板', '退款设置', '电子收据协议模板', '家长绑定配置'];
      const index = hideBtnList.findIndex(item => {
        return item === this.activeItem;
      });
      return index === -1;
    }
  },
  created() {
    this.schoolId = this.$route.query.schoolId;
    this.schoolName = this.$route.query.name;
    this.initRefund();
    this.initSchoolCanCheckRefund();
  },
  activated() {
    // this.$refs.PlatServeAgreementTemplete.getPlatTempleteList();
    this.$refs.ReceiptTemplete.getReceiptTempleteList();
  },
  methods: {
    ...mapMutations([
      'SET_CACHEROUTE',
      'PUSH_CACHEROUTE'
    ]),
    handleToOpenRec(recType) {
      this.$refs.recModal.handleShow({
        recType,
        objectId: this.schoolId,
        schoolName: this.schoolName
      });
    },
    async initRefund() {
      this.initloading = true;
      const params = { schoolId: this.schoolId };
      const res = await commonApi.getAutoRefundDtoApi(params);
      if (res.status == 200 && res.message) {
        if (res.message.yearCode) { this.initYear = [res.message.yearCode, String(res.message.termCode)]; }
        this.autoRefundTime = res.message.autoRefundTime || null;
        this.isEnable = res.message.isEnable || 0;
      } else { this.initYear = [null, null]; }
      this.initloading = false;
    },
    async initSchoolCanCheckRefund() {
      console.log('执行了查询的--------');
      const params = { schoolId: this.schoolId };
      const res = await courseCenterApi.getApproveRefundDtoBySchoolIdApi(params);
      if (res.status == 200 && res.message) {
        this.configStatus = +res.message;
      }
    },
    handleTime(v) {
      this.autoRefundTime = v;
    },
    closeBtn() {
      this.showtips = false;
    },
    async delTrue(code) {
      this.modalLoading = true;
      try {
        const yearTerms = this.$refs.cascaderYearTerms.getResult();
        const params = {
          'schoolId': this.schoolId, // 学校Id
          'yearCode': yearTerms[0] || null, // 学年编码
          'termCode': yearTerms[1] || null, // 学期编码
          'autoRefundTime': this.autoRefundTime || null, // 必传， 开启时，时间大于当前时间，关闭时传当前时间
          'isEnable': this.isEnable, // 0关闭 1开启
          'phoneCode': code // 短信验证码
        };
        const res = await commonApi.setAutoRefundApi(params);
        if (res.status == 200) {
          this.$refs.smsCodeModalRef.handleHide();
          this.showtips = true;
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.modalLoading = false;
      }
    },
    onYearTermInit() { },
    handleChangeSalary(status) {
      this.loadingSwitch = true;
      if (this.infoSwitchPayWages === '1' && status === false) {
        this.$nextTick(() => {
          this.switchPayWages = true;
        });
        this.$Message.error('改操作需要管理员确认，请联系管理员');
      }
      this.loadingSwitch = false;
    },
    handleSwitchTab(index) {
      this.active = index;
      this.tabLeftActive = 0;
    },
    handleChangeTabLeft(index) {
      this.tabLeftActive = index;
    },
    // 取消
    handleCancel() {
      this.$router.push({
        name: 'basicInfoCenter_company_schoolMage'

      });
    },
    handleSaveBtn() {
      this.btnLoading = true;
      if (this.activeItem === '家长端自动退款设置') {
        console.log('this.autoRefundTime', this.autoRefundTime);
        if (this.isEnable == 1 && !this.autoRefundTime) {
          this.$Message.error('请选择自动退款截止时间');
          return;
        }
        const yearAr = this.$refs.cascaderYearTerms.getResult();
        if (this.isEnable == 1 && !yearAr[0]) {
          this.$Message.error('请选择对应订单所属学期');
          return;
        }
        this.$refs.smsCodeModalRef.handleShow();
        return;
      }
      if (this.activeItem === '学校端是否可见审批') {
        this.setSchoolCanCheckRefund();
        return;
      }
      if (this.activeItem === '参与平台发放教师工资') {
        this.putTeacherSalary();
        return;
      }
      if (this.activeItem === '教师考勤补签') {
        this.putTeaSignDayScope();
        return;
      }
      if (this.activeItem === '学生考勤状态通知设置') {
        this.setStudentSignStatusNotification();
        return;
      }
      if (this.activeItem === '家长端发起请假截止') {
        this.setLeaveTime();
        return;
      }
      if (this.activeItem === '家长端发起学生请假审批设置') {
        this.setAutoLeave();
        return;
      }
      this.$refs.courseOthersRefs.handleSaveBtn();
    },
    onMessage(info) {
      console.log(info, '拿到了信息-----');
      this.switchParentPhoneNumber = +info.switchParentPhoneNumber === 1;
      this.switchCourseTeacher = +info.switchCourseTeacher === 1;
      this.switchOriginalSchool = +info.switchOriginalSchool === 1;
      this.switchPayWages = +info.switchPayWages === 1; // 是否发放教师工资 1开放 0不开放
      this.switchSignPlace = +info.switchSignPlace === 1;
      this.teaSignDayScope = info.teaSignDayScope;
      this.infoSwitchPayWages = info.switchPayWages;
      this.autoCheckLeavePassSwitch = +info.autoCheckLeavePassSwitch === 1 ? 1 : 0;
      if (info.studentSignStatusNotification) {
        this.$refs.signStatusNotificationRef.setFormValidate(info.studentSignStatusNotification);
      }
      if (info.parentLeaveTimeLimitDto) {
        this.hourAndMinTime = info.parentLeaveTimeLimitDto.hourAndMinTime;
      }
    },
    // 配置学校端是否可见审批退款
    async setSchoolCanCheckRefund() {
      const params = [{
        configStatus: this.configStatus,
        schoolId: this.schoolId,
        schoolName: this.schoolName
      }];
      try {
        this.$Spin.show();
        const res = await courseCenterApi.saveApproveRefundConfigApi(params);
        this.$Spin.hide();
        if (res.status === 200) {
          this.$Message.success('保存成功');
        }
      } catch (err) {
        this.$Spin.hide();
        console.log('err', err);
      }
    },
    // 教师工资
    async putTeacherSalary() {
      const params = {
        orgId: this.schoolId, // 学校id
        param: this.switchPayWages ? 1 : 0 // 1开放 0不开放
      };
      try {
        this.$Spin.show();
        const res = await courseCenterApi.postPayWagesApi(params);
        this.$Spin.hide();
        if (res.status === 200) {
          this.$Message.success('保存成功');
        }
      } catch (err) {
        this.$Spin.hide();
        console.log('err', err);
      }
    },
    // 教师考勤补签
    async putTeaSignDayScope() {
      if (isNaN(+this.teaSignDayScope)) {
        return this.$Message.error('请输入数字');
      }
      if (+this.teaSignDayScope < -1) {
        return this.$Message.error('请输入大于-1的整数');
      }
      if (!Number.isInteger(+this.teaSignDayScope)) {
        return this.$Message.error('请输入整数');
      }
      if (+this.teaSignDayScope > 999) {
        return this.$Message.error('最大值输入值为999');
      }
      const params = {
        orgId: this.schoolId, // 学校id
        param: this.teaSignDayScope// 设置教师补签范围 -1 表示不限，可任意补签；0表示只能补签当天的考勤；31表示只能补签距离当前日期31天前的班级考勤记录
      };

      try {
        this.$Spin.show();
        const res = await courseCenterApi.postTeaSignDayScopeApi(params);
        this.$Spin.hide();
        if (res.status === 200) {
          this.$Message.success('保存成功');
        }
      } catch (err) {
        this.$Spin.hide();
        console.log('err', err);
      }
    },
    async setStudentSignStatusNotification() {
      const info = this.$refs.signStatusNotificationRef.getParameter();
      if (info.settingSwitch == 1 && info.notifyUserType.length == 0) {
        this.$Message.warning('请选择要通知的用户');
        return null;
      }

      const res = await courseCenterApi.studentSignStatusNotificationApi({
        schoolId: this.schoolId, // 学校id
        notificationSettings: info
      });
      if (res.status == 200) {
        this.$Message.success('保存成功');
      }
      console.log(info, 'info');
    },
    // 设置请假截止时间
    async setLeaveTime() {
      const res = await courseCenterApi.setParentLeaveTimeLimitApi({
        schoolId: this.schoolId, // 学校id
        hourAndMinTime: this.hourAndMinTime
      });
      if (res.status == 200) {
        this.$Message.success('保存成功');
      }
    },
    // 设置发起请假是否需要任课教师审批
    async setAutoLeave() {
      const res = await courseCenterApi.setAutoCheckLeavePassApi({
        schoolId: this.schoolId, // 学校id
        settingSwitch: this.autoCheckLeavePassSwitch
      });
      if (res.status == 200) {
        this.$Message.success('保存成功');
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.tab-box {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ccc;
  .tab-item {
    padding: 8px 16px;
    border: 1px solid #ccc;
    font-size: 24px !important;
    line-height: 24px;
    border-radius: 4px 4px 0 0;
    margin-bottom: -1px;
    background: rgb(240, 244, 249);
    color: rgb(127, 127, 127);
    cursor: pointer;
  }
  .tab-item + .tab-item {
    margin-left: 8px;
  }
  .tab-item-active {
    color: #6149f1;
    border-bottom: 1px solid #fff;
    background: transparent;
  }
}
.tab-content {
  display: flex;
  margin-top: 25px;
  .content-left {
    width: 16%;
    box-sizing: border-box;
    border: 1px solid #ccc;
    flex-shrink: 0;
    .left-item {
      padding: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
    .left-item-active {
      color: #6149f1;
      background: #efecfd;
    }
  }
  .content-right {
    width: 84%;
    padding-left: 24px;
    .content-right-box {
      padding: 16px 0;
      p {
        margin-top: 16px;
      }
    }
  }
}
.tips {
  color: #999;
}

.redweight {
  font-weight: bold;
  color: red;
}
</style>
